import React, { useState, useEffect } from 'react';
import { searchApiRequest } from '@support/api';
import { RelatedContact } from '@models/Contact';
import Section from '@components/Section';
import styles from './Similar.module.scss';
import Avatar from '@components/Avatar';
import { Link } from 'react-router-dom';

export default function Similar({ contact, underline = true }) {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const abort = new AbortController();
    (async () => {
      try {
        const response = await searchApiRequest('GET', `contact/${contact.id}/related`, {
          query: {
            limit: 6,
          },
        });
        if (abort.signal.aborted) {
          return;
        }
        setContacts(response.hits.hits.map((hit: any) => new RelatedContact(hit._source)));
      } catch (_) {}
    })();

    return () => {
      abort.abort();
    };
  }, [contact.id]);

  return contacts.length > 0 ? (
    <Section>
      <Section.Title underline={underline}>Similar Profiles</Section.Title>
      <div className={styles.wrap}>
        {contacts.map((contact) => (
          <Link to={`/contact/${contact.id}`} key={contact.id} className={styles.item}>
            <Avatar
              url={contact.avatarURL}
              initials={contact.displayName ? contact.displayName[0] : ''}
              name={contact.displayName}
              square
              size="xs"
              className={styles.avatar}
              grayscale={contact.isMemorialized}
            />
            <div className={styles.name}>{contact.displayName}</div>
          </Link>
        ))}
      </div>
    </Section>
  ) : null;
}
